/**
 * @generated SignedSource<<b4c4360b693448d2fa2869aad0b72ad4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CalendarEventsFetch_Query$variables = {
  start?: string | null;
  end?: string | null;
  timezone?: string | null;
};
export type CalendarEventsFetch_Query$data = {
  readonly viewer: {
    readonly id: string;
    readonly component: string | null;
    readonly calendarIntegrations: {
      readonly calendarEvents: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly description: string | null;
            readonly start: string | null;
            readonly end: string | null;
            readonly calendarTimeZone: string | null;
            readonly allDay: boolean | null;
            readonly calendarId: string;
            readonly foregroundColor: string | null;
            readonly backgroundColor: string | null;
            readonly attendees: ReadonlyArray<string | null> | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type CalendarEventsFetch_Query = {
  variables: CalendarEventsFetch_Query$variables;
  response: CalendarEventsFetch_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timezone"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "google_calendar_events"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"google_calendar_events\")"
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "end",
      "variableName": "end"
    },
    {
      "kind": "Variable",
      "name": "start",
      "variableName": "start"
    },
    {
      "kind": "Variable",
      "name": "timezone",
      "variableName": "timezone"
    }
  ],
  "concreteType": "CalendarEventTypeConnection",
  "kind": "LinkedField",
  "name": "calendarEvents",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarEventTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEvent",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "calendarTimeZone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allDay",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "calendarId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "foregroundColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundColor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attendees",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarEventsFetch_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegrations",
            "kind": "LinkedField",
            "name": "calendarIntegrations",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CalendarEventsFetch_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarIntegrations",
            "kind": "LinkedField",
            "name": "calendarIntegrations",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fbc04a1671971b24d24ba9bbc886c818",
    "id": null,
    "metadata": {},
    "name": "CalendarEventsFetch_Query",
    "operationKind": "query",
    "text": "query CalendarEventsFetch_Query(\n  $start: String\n  $end: String\n  $timezone: String\n) {\n  viewer {\n    id\n    component(name: \"google_calendar_events\")\n    calendarIntegrations {\n      calendarEvents(start: $start, end: $end, timezone: $timezone) {\n        edges {\n          node {\n            id\n            name\n            description\n            start\n            end\n            calendarTimeZone\n            allDay\n            calendarId\n            foregroundColor\n            backgroundColor\n            attendees\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "694b70dda0695521e7001eb190db7fcc";

export default node;
